export default "__VITE_ASSET__7NdM7z$x__"